import { render } from "./index.vue?vue&type=template&id=5ca706a1&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=5ca706a1&lang=scss&scoped=true"

import exportComponent from "/Users/chanjack/Desktop/历史/iot-app-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca706a1"]])

export default __exports__